import React from 'react'
import { BsrsGrid, Column, commandColumnProps, EnumCellStatus, EnumFilterCell, DateCell, DueDateCell, DateFilterCell } from '@/components/BsrsGrid'
import { reportSubmissionGroupStatus } from '@/components/reporting/submissions/reportSubmissionsStatus'
import context from '@/context'
import { format } from '@/utils/StringUtilities'
import { ReportSubmissionGroupState } from '@/enums/ReportSubmissionGroupState'
import { useLocalization } from '@/hooks/localization'
import { downloadFile } from '@/utils/downloader'
import { NameColumn } from '../BsrsGrid/index'

function ReportSubmissionGroupGrid ({ forecasting, detailUrlFormat }) {
  const { localize, locale } = useLocalization()
  const stateEnumName = ReportSubmissionGroupState.enumName

  return <BsrsGrid persistenceId={'report-submission-group' + (forecasting ? '-forecasting' : '')} dataSource={request => context.api.reportSubmissionGroupService.getTableData(localize('Common.CBI'), forecasting, request)}
    defaultSort={[{ field: 'lastStateModificationTime', dir: 'desc' }]}>
    {NameColumn({ nameProp: 'institutionName', latinNameProp: 'institutionLatinName', locale, title: localize('Reporting.InstitutionName'), editable: false })}
    <Column field='name' title={localize('Common.Name')} editable={false} />
    <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
    <Column field='state' title={localize('Common.Status')} editable={false}
      cell={EnumCellStatus({ localize, enumName: stateEnumName, visualStatus: reportSubmissionGroupStatus })}
      filterCell={EnumFilterCell({ localize, enumName: stateEnumName }, ReportSubmissionGroupState.values)} enumName={stateEnumName} />
    <Column field='dueDate' title={localize('Reporting.DueDate')} filter='date' cell={DueDateCell} filterCell={DateFilterCell} editable={false} />
    <Column field='lastStateModificationTime' title={localize('Common.StatusChangedAt')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
    <Column field='lastStateModifierUserName' title={localize('Common.StatusChangedBy')} editable={false} />
    <Column field='creationTime' title={localize('Common.CreationTime')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />

    <Column {...commandColumnProps({
      detailUrl: x => format(detailUrlFormat, x.id),
      additionalButtons: x => {
        const downloadButtons = []

        if (x.arXlsxFileAttachmentId) {
          downloadButtons.push({
            icon: 'download',
            title: localize('Common.Arabic'),
            onClick: x => downloadFile({
              fileAttachmentId: x.arXlsxFileAttachmentId,
              reportSubmissionGroupId: x.id
            }, context.api.reportSubmissionGroupService.downloadExport, null, null, null)
          })
        }

        if (x.enXlsxFileAttachmentId) {
          downloadButtons.push({
            icon: 'download',
            title: localize('Common.English'),
            onClick: x => downloadFile({
              fileAttachmentId: x.enXlsxFileAttachmentId, reportSubmissionGroupId: x.id
            }, context.api.reportSubmissionGroupService.downloadExport, null, null, null)
          })
        }

        return downloadButtons
      }
    })} title=' ' width={150} />
  </BsrsGrid>
}

export default ReportSubmissionGroupGrid



// WEBPACK FOOTER //
// ./src/components/reporting/reportSubmissionGroupGrid.js